import type { EnemyKind } from "../generation/types";

export interface EnemyConfig {
  readonly kind: EnemyKind;
  readonly displayName: string;
  readonly maximumHealth: number;
  readonly movementSpeed: number;
  readonly detectionRange: number;
  readonly hearingRange: number;
  readonly fieldOfViewRadians: number;
  readonly attackRange: number;
  readonly attackCooldown: number;
  readonly attackDamage: number;
  readonly collisionRadius: number;
  readonly width: number;
  readonly height: number;
}

export const ENEMY_CONFIGS: Readonly<Record<EnemyKind, EnemyConfig>> = {
  rustSentinel: {
    kind: "rustSentinel", displayName: "Ржавый каратель",
    maximumHealth: 170, movementSpeed: 1.75, detectionRange: 25, hearingRange: 32,
    fieldOfViewRadians: Math.PI * 0.8, attackRange: 15, attackCooldown: 1.4,
    attackDamage: 16, collisionRadius: 0.75, width: 2.2, height: 2.8,
  },
  sporeCrawler: {
    kind: "sporeCrawler", displayName: "Споровый ползун",
    maximumHealth: 55, movementSpeed: 4.5, detectionRange: 20, hearingRange: 35,
    fieldOfViewRadians: Math.PI * 0.95, attackRange: 1.6, attackCooldown: 0.65,
    attackDamage: 9, collisionRadius: 0.55, width: 2.1, height: 1.2,
  },
  guard: {
    kind: "guard",
    displayName: "Одержимый страж",
    maximumHealth: 45,
    movementSpeed: 2.3,
    detectionRange: 22,
    hearingRange: 28,
    fieldOfViewRadians: Math.PI * 0.72,
    attackRange: 14,
    attackCooldown: 1.25,
    attackDamage: 8,
    collisionRadius: 0.55,
    width: 1.35,
    height: 2.35,
  },
  stalker: {
    kind: "stalker",
    displayName: "Пепельный охотник",
    maximumHealth: 100,
    movementSpeed: 3.1,
    detectionRange: 20,
    hearingRange: 32,
    fieldOfViewRadians: Math.PI * 0.82,
    attackRange: 11,
    attackCooldown: 1.65,
    attackDamage: 15,
    collisionRadius: 0.82,
    width: 2.05,
    height: 2.65,
  },
  boneHound: {
    kind: "boneHound",
    displayName: "Костяная гончая",
    maximumHealth: 65,
    movementSpeed: 4.2,
    detectionRange: 19,
    hearingRange: 34,
    fieldOfViewRadians: Math.PI * 0.9,
    attackRange: 1.65,
    attackCooldown: 0.78,
    attackDamage: 11,
    collisionRadius: 0.68,
    width: 1.9,
    height: 1.45,
  },
  choirAcolyte: {
    kind: "choirAcolyte",
    displayName: "Послушник Чёрного хора",
    maximumHealth: 82,
    movementSpeed: 2.05,
    detectionRange: 25,
    hearingRange: 31,
    fieldOfViewRadians: Math.PI * 0.78,
    attackRange: 16,
    attackCooldown: 1.85,
    attackDamage: 13,
    collisionRadius: 0.58,
    width: 1.55,
    height: 2.7,
  },
  forgeWarden: {
    kind: "forgeWarden",
    displayName: "Страж кузницы",
    maximumHealth: 260,
    movementSpeed: 2.45,
    detectionRange: 24,
    hearingRange: 34,
    fieldOfViewRadians: Math.PI * 0.86,
    attackRange: 12,
    attackCooldown: 1.35,
    attackDamage: 20,
    collisionRadius: 0.92,
    width: 2.35,
    height: 2.9,
  },
  abyssTyrant: {
    kind: "abyssTyrant",
    displayName: "Тиран Бездны",
    maximumHealth: 650,
    movementSpeed: 1.85,
    detectionRange: 29,
    hearingRange: 40,
    fieldOfViewRadians: Math.PI,
    attackRange: 18,
    attackCooldown: 1.1,
    attackDamage: 22,
    collisionRadius: 1.18,
    width: 3.1,
    height: 3.25,
  },
};
